import React from "react"
import Cabecalho from "../Cabecalho"
import { ExtratoPagarmeFornecedorView } from "./components/ExtratoPagarmeFornecedorView"

export function ExtratoPagarmeFornecedor() {
    return (
        <>
            <Cabecalho pagina="Extrato Pix Pagarme" />
            <ExtratoPagarmeFornecedorView />
        </>
    )
}
